import { config } from "../config";
import type { BannerState, ConnectionState, DeviceState } from "../types";
import { fmtAgo } from "./format";

export function deriveBanner(
  conn: ConnectionState,
  device: DeviceState,
): BannerState {
  const { connected, lastError } = conn;
  const { status, statusReason, lastTelemTs } = device;

  if (!connected && status === "unknown") {
    return {
      level: "grey",
      headline: "Connecting to AWS IoT…",
      detail: lastError ?? "",
    };
  }

  if (status === "offline") {
    const reason = statusReason ? ` (${statusReason})` : "";
    return {
      level: "red",
      headline: "ALERT — Device down" + reason,
      detail: `${device.meta.id} reported offline via retained status topic.`,
    };
  }

  if (
    lastTelemTs != null &&
    Date.now() - lastTelemTs > config.offlineThresholdMs
  ) {
    const secs = Math.floor((Date.now() - lastTelemTs) / 1000);
    return {
      level: "red",
      headline: `ALERT — No telemetry for ${secs}s`,
      detail: `Threshold is ${config.offlineThresholdMs / 1000}s. Device may be hung.`,
    };
  }

  if (lastTelemTs != null) {
    return {
      level: "green",
      headline: "Device up",
      detail: `Last heartbeat ${fmtAgo(lastTelemTs)}.`,
    };
  }

  if (connected) {
    return {
      level: "yellow",
      headline: "Connected — waiting for first telemetry…",
      detail: "",
    };
  }

  return {
    level: "grey",
    headline: "Disconnected from AWS IoT",
    detail: lastError ?? "Reconnecting…",
  };
}
